<template>
  <div class="inner" id="map"></div>
</template>

<script>
export default {
  data: function () {
      return {
          mapCore: {}
      }
  },
  props: {
    map: {
        type: Object,
        required: true
    }
  },
  methods: {
      createMap: function() {
          let app = this, map = this.el,
              coords = app.$props.map.coords;

          mapboxgl.accessToken = "pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g";

          app.mapCore = new mapboxgl.Map({
              container: map,
              style: 'mapbox://styles/mapbox/streets-v11',
              center: coords,
              zoom: app.$props.map.zoom,
              minZoom: app.$props.map.minZoom,
              maxZoom: app.$props.map.maxZoom
          });
          app.mapCore.addControl(new mapboxgl.NavigationControl(), 'top-left');
          app.mapCore.addControl(new mapboxgl.ScaleControl({ unit: "imperial" }));

          st.remove(document.querySelector(".mapboxgl-ctrl-logo").parentNode);

          new mapboxgl.Marker().setLngLat(coords).addTo(app.mapCore);
      },
      handleScroll: function(e) {
          let app = this;
          let scroll = e.currentTarget.pageYOffset;
          let map = app.el.getBoundingClientRect().top;
          let isShowing = app.inViewport(app.el);
          if (scroll > map && isShowing) {
              app.createMap();
              window.removeEventListener('scroll', this.handleScroll);
          }
      },
      inViewport: function(el) {
          let box = el.getBoundingClientRect();
          return (
              box.top >= 0 &&
              box.left >= 0 &&
              box.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              box.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
      }
  },
  mounted: function() {
      this.el = this.$el;
      window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function() {
      window.removeEventListener('scroll', this.handleScroll);
  }
}

</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.inner {
  background: #424F98;
  margin: 1.25rem 0;
  top: .0625rem;
  height: 26.563rem;
  width: 100%;
}

</style>
